import React, { useEffect } from "react";

const LoadingSpinner: React.FC = () => {
    useEffect(() => {
        // Inject keyframe animations into the document if not already present
        const styleId = "loading-spinner-keyframes";
        if (!document.getElementById(styleId)) {
            const style = document.createElement("style");
            style.id = styleId;
            style.textContent = `
                @keyframes colorCycle1 {
                    0%, 100% { background-color: #00175c; }
                    25% { background-color: #4b6bfb; }
                    50% { background-color: #879efc; }
                    75% { background-color: #d1d5db; }
                }

                @keyframes colorCycle2 {
                    0%, 100% { background-color: #879efc; }
                    25% { background-color: #d1d5db; }
                    50% { background-color: #00175c; }
                    75% { background-color: #4b6bfb; }
                }

                @keyframes colorCycle3 {
                    0%, 100% { background-color: #4b6bfb; }
                    25% { background-color: #879efc; }
                    50% { background-color: #d1d5db; }
                    75% { background-color: #00175c; }
                }
            `;
            document.head.appendChild(style);
        }

        return () => {
            // Optionally clean up when component unmounts
            const style = document.getElementById(styleId);
            if (style) {
                style.remove();
            }
        };
    }, []);

    return (
        <div className="flex flex-col items-center justify-center py-4">
            <div className="text-center">
                <p className="text-base text-gray-700 mb-4">
                    Searching for available flights, please wait...
                </p>
                <div className="flex items-center justify-center gap-1">
                    <div
                        className="w-2 h-2 rounded-full"
                        style={{
                            animation: "colorCycle1 1s ease-in-out infinite",
                        }}
                    ></div>
                    <div
                        className="w-2 h-2 rounded-full"
                        style={{
                            animation: "colorCycle2 1s ease-in-out infinite",
                        }}
                    ></div>
                    <div
                        className="w-2 h-2 rounded-full"
                        style={{
                            animation: "colorCycle3 1s ease-in-out infinite",
                        }}
                    ></div>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;
